import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { PrimaryButton, TextButton } from '@bibliocommons/base-buttons';
import { branchShape } from '@bibliocommons/bc-prop-types';
import HelpLinkContainer from '../../../../containers/HelpLinkContainer';
import BranchDropdown from '../../../shared/BranchDropdown';

import './SingleClickHoldsForm.scss';

export default class SingleClickHoldsForm extends BcReactComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedBranchCode: this.props.branchCode || props.branches.first().get('code')
    };

    this.bindAll('handleSelect', 'handleSubmit');
  }

  handleSelect(branchCode) {
    this.setState({
      selectedBranchCode: branchCode
    });
  }

  handleSubmit() {
    this.props.handleSubmit({
      branchCode: this.state.selectedBranchCode
    });
  }

  render() {
    return (
      <form className="cp-single-click-holds-form">
        <HelpLinkContainer page="010singleclick" />
        <h3><FormattedMessage id="single_click_holds_form_title" /></h3>

        <BranchDropdown
          branches={this.props.branches}
          handleSelect={this.handleSelect}
          selectedBranchCode={this.state.selectedBranchCode}>
          <FormattedMessage id="single_click_holds_location_label" />
        </BranchDropdown>

        <p className="small description">
          <FormattedMessage id="single_click_holds_location_description" />
        </p>

        <PrimaryButton className="save-button" handleClick={this.handleSubmit}>
          <FormattedMessage id="button_save" />
        </PrimaryButton>

        <TextButton className="cancel-button" handleClick={this.props.handleCancel}>
          <FormattedMessage id="button_cancel" />
        </TextButton>
      </form>
    );
  }
}

SingleClickHoldsForm.propTypes = {
  branches: ImmutablePropTypes.listOf(branchShape),
  branchCode: PropTypes.string,
  handleCancel: PropTypes.func,
  handleSubmit: PropTypes.func
};



// WEBPACK FOOTER //
// ./app/components/borrowing/sidebar/SingleClickHoldsForm/SingleClickHoldsForm.jsx